import PaymentStatus from './PaymentStatus.component';

export default PaymentStatus;